<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.DataComparison')"
    width="1300px"
    append-to-body
    :close-on-click-modal="false"
  >
    <div>
      <div style="display: flex">
        <cargo-ag-grid
          config-module="26000526"
          :grid-options="cabinDataComparison.gridOptions"
          :column-defs="columnDefs"
          :row-data="cabinDataComparison.rowData"
          :grid-params.sync="cabinDataComparison.gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          style="margin-top: 10px;height: 200px;width: 500px"
          @gridReady="params=>cabinDataComparison.gridApi=params.api"
        />
      </div>
      <div style="word-wrap: break-word; white-space: normal;font-family: sans-serif;margin: 15px 0 10px 30px">
        <el-row>
          <el-col :span="1">
            <label>{{ $t('CargoMsg.Cargo_Note') }}：</label>
          </el-col>
          <el-col :span="15">
            <label>{{ $t('CargoMsg.Cargo_TheRedFontFieldWillOverwriteTheSeaExportWithTheValueOfTheSpaceManagement') }}</label>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="1" style="min-height: 1px;" />
          <el-col :span="15">
            <label>{{ $t('CargoMsg.Cargo_OriginalValueOfTheSeaExportAndWillNotBeOverwritten') }}</label>
          </el-col>
        </el-row>
      </div>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect.vue'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import { cache, cacheName } from '@/utils/cacheManager'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'CabinDataComparisonDialog',
  components: {
    cargoOfficeSelect, CargoSalesCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    list: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      fullscreenLoading: false,
      cabinDataComparison: {
        gridApi: null,
        gridParams: {},
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressRowClickSelection: true
        }
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.ChargeSource'),
          field: 'dataSource',
          colId: 'dataSource',
          width: 150,
          valueFormatter: (params) => {
            return params.value ? this.$t('CargoMsg.Cargo_CabinManagement') : this.$t('CargoMsg.Cargo_OceanExport')
          }
        },
        {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          cellStyle: this.setCellFieldStyle,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          cellStyle: this.setCellFieldStyle,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          cellStyle: this.setCellFieldStyle,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5') : ''
          },
          width: 200
        },
        {
          headerName: 'ETD',
          colId: 'etd',
          field: 'etd',
          cellStyle: this.setCellFieldStyle,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: 'S/O NO.',
          colId: 'soNo',
          field: 'soNo',
          cellStyle: this.setCellFieldStyle,
          width: 150
        }, {
          headerName: 'MB/L NO.',
          colId: 'mbl',
          field: 'mbl',
          cellStyle: this.setCellFieldStyle,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.PortOfLoadingAI'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          cellStyle: this.setCellFieldStyle,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 170
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: 'dischargingPortCode',
          cellStyle: this.setCellFieldStyle,
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          cellStyle: this.setCellFieldStyle,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          cellRenderer: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          cellStyle: this.setCellFieldStyle,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          cellStyle: this.setCellFieldStyle,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          cellStyle: this.setCellFieldStyle,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          },
          width: 150
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true
    }
    await cache.load(cacheName.CONFIG)
    if (this.innerVisible) {
      await this.init()
    }
  },
  methods: {
    async enterHandler() {
      this.$emit('confirmSync')
      this.close()
    },
    async init() {
      this.cabinDataComparison.rowData = this.list
    },
    setCellFieldStyle(item) {
      const field = item.column.colId
      const dataSource = item.data.dataSource
      const cabinManagement = this.list[0]
      const job = this.list[1]
      if (cabinManagement && job) {
        if (cabinManagement[field] && cabinManagement[field] !== job[field]) {
          if (dataSource) {
            return { 'color': 'red' }
          }
        } else if (!cabinManagement[field] && job[field]) {
          if (!dataSource) {
            return { 'color': 'blue' }
          }
        }
      }
      return { }
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
